import { Adapter as t } from "../../../../../adapter.js";
import { ShopSessionPaymentMethodModel as n } from "./paymentMethod.model.js";
class r extends t {
  adapt(e) {
    return new n({
      methodType: e.method_type,
      engine: e.engine,
      serviceType: e.service_type,
      channel: e.channel,
      status: e.status
    });
  }
  serialize(e) {
  }
}
export {
  r as ShopSessionPaymentMethodAdapter
};
//# sourceMappingURL=paymentMethod.adapter.js.map
